import { supabase } from '@/lib/supabaseClient';

/**
 * Singleton API Client wrapper to enforce strictly typed and secure network calls.
 * Ensures '403 ONBOARDING_REQUIRED' errors are caught safely outside the React component lifecycle.
 */

export const apiFetch = async (
    input: RequestInfo | URL, 
    init?: RequestInit, 
    router?: { replace: (url: string) => void }
): Promise<Response> => {
    const response = await fetch(input, init);

    if (response.status === 403) {
        try {
            const clonedRes = response.clone();
            const data = await clonedRes.json();
            
            if (data.code === 'ONBOARDING_REQUIRED' || data.error === 'ONBOARDING_REQUIRED') {
                console.warn('[apiFetch Shield] Caught ONBOARDING_REQUIRED status. Escaping safely.');
                
                // Safe native redirect without monkey-patching or rejecting into React cycle
                if (router) {
                    router.replace('/wallet/onboarding');
                } else if (typeof window !== 'undefined') {
                    window.location.href = '/wallet/onboarding';
                }
                
                // Return original response instead of Promise.reject to prevent unhandled rejection cascades
            }
        } catch (e) {
            // Non-JSON 403, proceed natively
        }
    }

    return response;
};
